import { ChangeEvent, useRef } from "react";

type FormType = "input" | "select" | "textarea" | "email";

const FormItem = ({
  type,
  keyFrom,
  placeholder,
  required,
  form,
  onChange,
}: {
  type: FormType;
  keyFrom: string;
  placeholder: string;
  required?: boolean;
  form: any;
  onChange: (value: string) => void;
}) => {
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  const handleChange = (
    event: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
  ) => {
    onChange(event.target.value);
    adjustHeight();
  };

  const adjustHeight = () => {
    const textarea = textareaRef.current;
    if (textarea) {
      textarea.style.height = "auto";
      textarea.style.height = `${textarea.scrollHeight}px`;
    }
  };

  if (["input", "textarea", "email"].includes(type))
    return (
      <div className="form__group field">
        {type === "input" || type === "email" ? (
          <input
            type={type}
            className="form__field"
            placeholder={placeholder}
            name={keyFrom}
            id={keyFrom}
            required={required}
            value={form[keyFrom]}
            onChange={handleChange}
          />
        ) : (
          <textarea
            className="form__field"
            placeholder={placeholder}
            name={keyFrom}
            id={keyFrom}
            required={required}
            value={form[keyFrom]}
            onChange={handleChange}
          />
        )}
        <label className="form__label">{placeholder}</label>
      </div>
    );

  return <></>;
};

export default FormItem;
